// extracted by mini-css-extract-plugin
export default {"navlink":"Navbar_navlink__6C0Rr","active":"Navbar_active__em+eI"};